import {useTranslation} from 'react-i18next'
import {useMemo} from 'react'
import {localizedPaths} from '~/utils/routes'
import {Link} from 'react-router'
import clsx from 'clsx'

const formatPath = (path: string) => path.split('/').pop()?.replace(/-/g, ' ')

export const LanguagesShowcase = () => {
  const {i18n} = useTranslation()

  // We're using paths as opposed to translated keys since it's currently the only place where
  // we have fully SEO-optimized keywords. For example, the italian nav label is "Traduci"
  // (non optimized), instead of "Traduttore" (optimized).
  const keywords = useMemo(() => {
    const translatePaths = {...localizedPaths['/translate']}
    const filteredTranslatePaths = Object.fromEntries(
      Object.entries(translatePaths).filter(([key]) =>
        i18n.language === 'id' ? key !== 'it' : key !== 'id'
      )
    )
    return Object.values(filteredTranslatePaths)
  }, [i18n.language])

  return (
    <section className="flex w-full justify-center bg-[#5E61F1]">
      <div
        className={clsx(
          'text-sm capitalize text-neutral-25',
          'flex w-full max-w-7xl flex-wrap gap-5',
          'sm:grid sm:grid-flow-col sm:grid-cols-4 sm:grid-rows-8 sm:gap-x-6 sm:gap-y-3 lg:gap-x-12'
        )}
      >
        {keywords.map(path => (
          <Link
            key={path}
            to={encodeURIComponent(path.replace(/^\//, ''))}
            reloadDocument
            className="w-fit transition-colors hover:text-primary-500"
          >
            {formatPath(path)}
          </Link>
        ))}
      </div>
    </section>
  )
}
